import { api } from "@/api/axios.ts";
import {
  ApiPeopleAnalyticsCacheState,
  ApiPeopleAnalyticsCatalog,
  ApiPeopleAnalyticsRows,
  ApiPeopleAnalyticsRowsInput,
  ApiPeopleAnalyticsDashboard,
  ApiPeopleAnalyticsWidget,
  ApiPeopleAnalyticsWidgetDataInput,
  ApiPeopleAnalyticsWidgetSaveInput,
} from "@/types/reporting/people-analytics.types.ts";
import { ApiWidgetData } from "@/types/reporting/reporting.types.ts";

export const peopleAnalyticsApi = {
  columns(signal?: AbortSignal) {
    return api.get<ApiPeopleAnalyticsCatalog>(`/api/v1/analytics/people/columns`, {}, signal);
  },
  rows(input: ApiPeopleAnalyticsRowsInput, signal?: AbortSignal) {
    return api.post<ApiPeopleAnalyticsRows>(`/api/v1/analytics/people/rows`, input, signal);
  },
  rowsExport(input: ApiPeopleAnalyticsRowsInput, signal?: AbortSignal) {
    return api.post<BlobPart>(`/api/v1/analytics/people/rows`, input, signal, {
      responseType: "blob",
    });
  },
  widgets(signal?: AbortSignal) {
    return api.get<ApiPeopleAnalyticsWidget[]>(`/api/v1/analytics/people/widgets`, {}, signal);
  },
  createWidget(input: ApiPeopleAnalyticsWidgetSaveInput) {
    return api.post<ApiPeopleAnalyticsWidget>(`/api/v1/analytics/people/widgets`, input);
  },
  updateWidget(widgetId: number, input: ApiPeopleAnalyticsWidgetSaveInput) {
    return api.put<ApiPeopleAnalyticsWidget>(`/api/v1/analytics/people/widgets/${widgetId}`, input);
  },
  deleteWidget(widgetId: number) {
    return api.delete<void>(`/api/v1/analytics/people/widgets/${widgetId}`);
  },
  widgetData(widgetId: number, input: ApiPeopleAnalyticsWidgetDataInput, signal?: AbortSignal) {
    return api.post<ApiWidgetData>(
      `/api/v1/analytics/people/widgets/${widgetId}/data`,
      input,
      signal
    );
  },
  cacheState(signal?: AbortSignal) {
    return api.get<ApiPeopleAnalyticsCacheState>(`/api/v1/analytics/people/cache`, {}, signal);
  },
  rebuildCache() {
    return api.post<ApiPeopleAnalyticsCacheState>(`/api/v1/analytics/people/cache/rebuild`, {});
  },
  dashboards(signal?: AbortSignal) {
    return api.get<ApiPeopleAnalyticsDashboard[]>(
      `/api/v1/analytics/people/dashboards`,
      {},
      signal
    );
  },
};
